module.exports = __webpack_public_path__ + "img/becks.f9b344d0.png";